import { atom } from 'jotai'

/**
 * Stores the current editor's block outline as a formatted string.
 * Updated by policy editor pages when the TipTap editor mounts/changes.
 * Read by ScreenataWorkspaceChat's getPageContent to include in LLM context.
 */
export const editorBlockOutlineAtom = atom<string | null>(null)
